/*
 * Description: Application Main Web Component
 * Purpose: A reusable wrapper for the main content area of the application
 * Author: Nuvemx
 * Created: 2026
 *
 * Usage:
 * <application-main></application-main>
 */

class application_main extends HTMLElement {
    connectedCallback() {
        if (this.dataset.rendered) {
            return;
        }
        const internalContent = this.innerHTML;
        this.innerHTML = `<main class="main">${internalContent}</main>`;
        this.dataset.rendered = "true";
    }
}

export { application_main };
